import { render } from "./LegoNeedAssistance.vue?vue&type=template&id=97c99e8a&scoped=true"
import script from "./LegoNeedAssistance.vue?vue&type=script&lang=js"
export * from "./LegoNeedAssistance.vue?vue&type=script&lang=js"

import "./LegoNeedAssistance.vue?vue&type=style&index=0&id=97c99e8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-97c99e8a"

export default script